<template>
	<div class="w-100">
		<div class="row">
			<div class="col-12 col-md-6">
				<label for="licence_option">Option de licence</label>
				<e-select
					v-model="option"
					id="licence_option"
					track-by="option_id"
					label="option_label"
					placeholder="Choisir une option"
					:options="all_options"
					:searchable="true"
					:allow-empty="false"
					:show-labels="false"
					:loading="loading_options"
				>
					<template slot="noOptions">{{ $t('global.list_empty') }}</template>
				</e-select>
			</div>
		</div>

		<div class="row" v-if="option">
			<div class="col-12">
				<div class="box mt-3">
					<LoadingSpinner v-if="loading_licences" />
					<p v-else-if="licences && licences.length == 0">Aucune licence ne possède cette option</p>
					<table v-else class="table table-variante">
						<tr>
							<th>Nom de la licence</th>
							<th>Email de l'administrateur</th>
							<th>Clé de licence</th>
						</tr>
						<tr v-for="licence in licences" :key="licence.licence_key">
							<td>{{ licence.licence_name }}</td>
							<td>{{ licence.user_email }}</td>
							<td>{{ licence.licence_key }}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Statistiques from '@/mixins/Statistiques.js'
	import User from '@/mixins/User.js'

	export default {
		name: 'OptionsLicence',
		mixins: [Statistiques, User],
		data () {
			return {
				all_options: [],
				option: null,
				licences: null,
				loading_options: false,
				loading_licences: false
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.loading_options = true
				this.all_options = await this.getOptions() || []
				this.loading_options = false
			},

			async loadLicences() {
				this.licences = null
				if(!this.option) {
					return
				}

				this.loading_licences = true
				this.licences = await this.getLicencesByOption(this.option.option_id) || []
				this.loading_licences = false
			}
		},

		watch: {
			option() {
				this.loadLicences()
			}
		},

		components: {
			LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35')
		}
	}

</script>
